import { memo, useCallback, useMemo } from 'react'

import { IContact } from 'clickNgo/entities/contact'
import { Nullable } from 'cng-common/models/utils'

import { ContactDeactivationStep } from '../../../configs'
import { useReassignment } from '../../../contexts'
import { ContactDeactivationStepProps, ReassignmentItem } from '../../../models'
import { contactDeactivationModalTranslations } from '../../../translation'
import { Reassignment } from '../../reassignment'

export const ReassignRolesStep = memo<ContactDeactivationStepProps>(({ onCancel, onProceed }) => {
  const { rolesToReassign, flagsToReassign, updateRoleAssignment } = useReassignment()

  const items: ReassignmentItem[] = useMemo(
    () =>
      rolesToReassign.map((role) => ({
        key: role.role,
        displayName: role.role,
        contact: role.contact,
      })),
    [rolesToReassign]
  )

  const handleProceedClick = useCallback(() => {
    if (flagsToReassign.length > 0) {
      onProceed(ContactDeactivationStep.ReassignFlags)
    } else {
      onProceed(ContactDeactivationStep.Completion)
    }
  }, [flagsToReassign, onProceed])

  const handleRoleChange = useCallback(
    (roleKey: string, contact: Nullable<IContact>) => {
      updateRoleAssignment(roleKey, contact)
    },
    [updateRoleAssignment]
  )

  return (
    <Reassignment
      title={contactDeactivationModalTranslations.reassignRolesStep.title}
      description={contactDeactivationModalTranslations.reassignRolesStep.description}
      items={items}
      onItemChange={handleRoleChange}
      onCancel={onCancel}
      onProceed={handleProceedClick}
    />
  )
})

ReassignRolesStep.displayName = 'ReassignRolesStep'
